function safeTrack(event, data) {
  if (typeof analytics !== 'undefined') {
    // eslint-disable-next-line
    return analytics.track(event, data);
  }
  return null;
}
export default function track(event, data) {
  return safeTrack(event, data);
}